export const FamilyMapping = {
    "AutomaticCapacitorBank": "Bancos y dispositivos de compensación",
    "Bus": "Equipos de distribución",
    "BusMononodo": "Equipos de distribución",
    "Cable": "Equipos de distribución",
    "DistributionBoard": "Equipos de distribución",
    "DistributionLine": "Equipos de distribución",
    "ElectricEnergySupplier": "Fuentes de energía",
    "Electroduct": "Equipos de distribución",
    "ElectromagneticSwitch": "Protección contra sobrecorriente",
    "ElectronicRelay": "Electrónica de potencia",
    "EngineControlCenter": "Equipos de distribución",
    "FixedCapacitorBank": "Bancos y dispositivos de compensación",
    "Fuse": "Protección contra sobrecorriente",
    "FuseMt": "Protección contra sobrecorriente",
    "Generator": "Cargas",
    "InductionMotor": "Cargas",
    "LightningContactChargingCenter": "Medición",
    "MagneticSwitch": "Protección contra sobrecorriente",
    "OverloadRelay": "Bancos y dispositivos de compensación",
    "PhotovoltaicGenerator": "Fuentes de energía",
    "PowerSwitch": "Protección contra sobrecorriente",
    "SoftStarter": "Electrónica de potencia",
    "Subdiagram": "Subdiagramas",
    "Switch": "Transformadores",
    "SynchronousMotor": "Cargas",
    "ThermomagneticSwitches": "Protección contra sobrecorriente",
    "ThreeWindingTransformer": "Transformadores 3 devanados",
    "TwoWindingTransformer": "Transformadores 2 devanados",
    "Ups": "Fuentes de energía",
    "Vfd": "Equipos de distribución",
};
